import React, { useCallback, useState } from 'react'

import i18n from 'i18n-literally'
import PropTypes from 'prop-types'

import { IMaskInput } from 'react-imask'

import { EMPTY_OBJECT, noop } from '~/src/Lib/Utils'

import TextField from './TextField'

const phoneRegExp = /(^$)|(^\d{10}$)/

const MaskedInput = React.forwardRef((props, ref) => <IMaskInput {...props} mask="(000) 000-0000" ref={ref} />)

export const PhoneFieldComponent = ({
  errorText = i18n`Please enter a valid phone number`,
  inputProps = EMPTY_OBJECT,
  InputProps = EMPTY_OBJECT,
  name = null,
  value = '',
  onChange,
  ...passthru
}, ref) => {
  const [touched, setTouched] = useState(false)
  const onBlur = useCallback(() => setTouched(true), [setTouched])
  const error = touched && !phoneRegExp.test(value) ? errorText : null

  return (
    <TextField
      data-testid="phone-text-field"
      {...passthru}
      fullWidth
      maxLength={30}
      type="text"
      error={error}
      value={value}
      onBlur={onBlur}
      onChange={noop}
      innerRef={ref}
      inputProps={{
        ...inputProps,
        onAccept: (_, mask) => {
          onChange(name ? { [name]: mask.unmaskedValue } : mask.unmaskedValue)
        }
      }}
      InputProps={{
        ...InputProps,
        inputComponent: MaskedInput
      }}
    />
  )
}
PhoneFieldComponent.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  errorText: PropTypes.string,
  inputProps: PropTypes.shape({}),
  InputProps: PropTypes.shape({
    endAdornment: PropTypes.node,
    startAdornment: PropTypes.node,
  }),
  onChange: PropTypes.func.isRequired,
}

const Memoized = React.memo(PhoneFieldComponent)

export default Memoized
